import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import { getDocument } from '../../../../Actions/General';
import Buttoncontrol from "../../../GeneralUI/Buttoncontrol";
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import { errorSetter } from '../../../../Libs/';
import AutoComplete from '../../../GeneralUI/AutoComplete';
import PSelect from '../../../GeneralUI/PSelect'

class Anulacion extends Component {
  constructor(props) {
    super(props);

    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    fields: {
      manifiestoCodigo: null,
      anulacionMotivo: null,
      liberarPedido:null
    },
    responseForm: { Message: '', typeMessage: '' },
    formValidations: {
      view: ['manifiestoCodigo','liberarPedido', 'anulacionMotivo']
    },
    formErrors: {
      manifiestoCodigo: {},
      anulacionMotivo: {},
      liberarPedido: {}
    }
  };

  componentDidMount() {
    const params = this.props.match.params;

    if (!params.id) {
      return;
    }

    getDocument({
      documentId: params.id,
      fieldName: 'manifiestoCodigo',
      moduleName: params.module
    }).then(document => {
      if (!document) {
        return;
      }
      this.setState({ fields: document });
    });

  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    fields[event.target.id] = event.target.value.toUpperCase();
    this.setState({ fields });
  }

  save = (response) => {

    let newState={
      data: response.data,
      responseForm: response.responseForm
    };

    this.setState(newState);

    this.message(newState.responseForm['typeMessage'], newState.responseForm['Message']);
  }

  message = (type, message) => {
    this.props.enqueueSnackbar(message, { variant: type });
  }

  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={3} className={classes.gridForm}>

            <InputLabel className={classes.tittleLabelForm}>
              Anulacion manifiesto
            </InputLabel>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={classes.gridForm}>
              <AutoComplete
                id='manifiestoCodigo'
                tableName='vw_manifiesto_anulacion'
                fields={['manifiesto_codigo', 'ruta']}
                aliases={[{ value: 'ID', size: 6 },  { value: 'RUTA', size: 6 }]}
                size='xl'
                primaryField='manifiesto_codigo'
                aliases={['ID', 'Ruta']}
                searchField='manifiesto_codigo'
                placeHolder='Manifiesto'
                onSelect={this.handleChange}
                value={this.state.fields["manifiestoCodigo"]}
                isView={true}
                where={{
                  manifiestoEstado: 'ACTIVO'
                }}
                formErrors={this.state.formErrors['manifiestoCodigo']}
              />
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
                <PSelect
                  id="liberarPedido"
                  useChildren={true}
                  value={this.state.fields["liberarPedido"]}
                  onChange={this.handleChange}
                  namelabel="Liberar Pedido"
                >
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </PSelect>
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id="anulacionMotivo"
                label="Motivo"
                type="text"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                multiline={true}
                rows={3}
                rowsMax={3}
                value={this.state.fields["anulacionMotivo"]}
                error={this.state.formErrors['anulacionMotivo'].error}
                helperText={this.state.formErrors['anulacionMotivo'].errorMessage}
              />
            </Grid>
          </Grid>
        </form>

        <div id='buttonContainer'>
          <Buttoncontrol
            saveData={this.state.fields}
            moduleName='manifiesto'
            save={this.save}
            primaryFields={['manifiestoCodigo']}
            formValidations={this.state.formValidations}
            errorHandler={this.setErrors}
            url='/processes/manifiesto_anulacion'
            isFormLite={true}
          />
        </div>

      </Paper>
    );
  }
}

Anulacion.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(Anulacion)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;